import { Treatment } from 'src/constants/Split';

export const formatTestExperience = (flag: string, treatment: boolean) => {
  const variant = treatment ? Treatment.On : Treatment.Off;
  return `${flag}_${variant}`;
};
